import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import THEME from '../theme';
import List from './Icons/List';
import { CopyToClipboard, Button, Modal } from '.';
const PageMenu = (props) => {
    const [optionsModalOpen, setOptionsModalOpen] = useState(false);
    return (React.createElement(PageMenuStyled, null,
        props.contentRight && (React.createElement(ContentRight, null,
            React.createElement(HideOnMobile, null, props.contentRight),
            React.createElement(OnlyOnMobile, null,
                props.mobileMenu,
                React.createElement(Button, { size: "small", onClick: () => setOptionsModalOpen(!optionsModalOpen) },
                    React.createElement(List, null))))),
        React.createElement(ContentLeft, null,
            React.createElement("h3", { className: "breadcrumb page-title" }, props.breadCrumb
                .map(({ path, copyToClipBoard, text }, i) => copyToClipBoard ? (React.createElement(CopyToClipboard, { key: path, iconStyle: {
                    height: '16px',
                    width: '16px',
                }, text: `${copyToClipBoard}` }, text)) : (
            // @ts-ignore
            React.createElement(Link, { to: path, key: path }, text)))
                .reduce((accu, elem) => accu === null ? [elem] : [...accu, ' / ', elem], [])
                .slice(1) || 'Home'),
            React.createElement(HideOnMobile, { style: { display: 'flex' } }, props.contentLeft && props.contentLeft)),
        props.subTitle && React.createElement("div", null, props.subTitle),
        optionsModalOpen && (React.createElement(Modal, { onToggle: () => setOptionsModalOpen(!optionsModalOpen) },
            React.createElement("div", null, props.contentRight),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", null, props.contentLeft)))));
};
export default PageMenu;
const PageMenuStyled = styled.div `
  border-bottom: 2px solid ${THEME.COLOR_PRIMARY};
  margin-bottom: ${THEME.GRID_SPACING}px;
  color: ${THEME.COLOR_PRIMARY};
  min-height: 45px;

  .breadcrumb {
    background-color: transparent;
    float: left;
    font-size: 1.2em;
    font-weight: 300;
    line-height: 30px;
    margin: 0;
    padding: 0;
    transition: padding 0.25s ease-in-out;
    color: ${THEME.COLOR_GREY};

    a {
      text-decoration: none;
      color: inherit;
    }

    a:hover {
      text-decoration: underline;
    }

    .active {
      font-weight: 400;
    }

    a:last-child,
    div:last-child {
      font-weight: bold;
      color: ${THEME.COLOR_PRIMARY};
    }
  }
`;
const ContentRight = styled.div `
  float: right;
`;
const ContentLeft = styled.div ``;
const HideOnMobile = styled.div `
  @media ${THEME.MEDIA_QUERY_MOBILE} {
    display: none;
  }
`;
const OnlyOnMobile = styled.div `
  display: none;
  @media ${THEME.MEDIA_QUERY_MOBILE} {
    display: inherit;
  }
`;
//# sourceMappingURL=PageMenu.js.map